module.exports = __webpack_public_path__ + "img/38.c1df44b5.png";